import apiOpname from '@/api/stockOpname';
import apiOption from '@/api/option';

const defaultState = () => ({
	listOpname: [],
	detailOpname: {},
	opnamePagination: '',
  opnameforApprove: [],
  warehouseResults:[],
	response: {
		code: '',
		message: '',
	},
	dataImport: [],
	alertMultiple: [],
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setOpname(state, data) {
		state.listOpname = data.data
		state.opnamePagination = data.pagination;
	},
	setDetailOpname(state, data) {
		state.detailOpname = data
	},
	setOpnameforApprove(state, data) {
		state.opnameforApprove = data
	},
  setWarehouseResults(state, data) {
		state.warehouseResults = data
	},
	saveImportData(state, data) {
		state.dataImport = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataOpname(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getOpname({ commit }, params) {
		return new Promise((resolve) => {
			apiOpname.getOpname(params).then(({ data: { data } }) => {
				commit('setOpname', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setOpname', { data: [], pagination: {} });
			});
		});
	},
	getOpnameAll({ commit }, params) {
		return new Promise((resolve) => {
			apiOpname.getOpnameAll(params).then(({ data: { data } }) => {
				commit('setOpname', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setOpname', { data: [], pagination: {} });
			});
		});
	},
  getWarehouseOption({ commit }, params) {
		return new Promise((resolve) => {
			apiOption.getOptionWarehouseAll(params).then(({ data: { data } }) => {
				commit('setWarehouseResults', data.results);
				resolve()
			}).catch(() => {
				commit('setWarehouseResults', []);
			});
		});
	},
	getDetailOpname({ commit }, params) {
		apiOpname.getDetailOpname(params).then(({ data: { data } }) => {
			commit('setDetailOpname', data.results);
		}).catch(() => {
			commit('setDetailOpname', []);

	// getDetailOpname({ commit, dispatch }, params) {
	// 	apiOpname.getDetailOpname(params).then(({ data: { data } }) => {
	// 		commit('setDetailOpname', data.results );
	// 	}).catch((err) => {
	// 		const data = err.response.data
	// 		dispatch("errorHandler", data)
	// 		commit('setDetailOpname', {});

    });
	},
	async exportOpname({ commit, dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiOpname.exportOpname(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Stok Opname'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
  async exportOpnameAll({ commit, dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiOpname.exportOpnameAll(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Stok Opname'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportTemplateOpname({ commit, dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiOpname.exportTemplateOpname(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Stok Opname'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async importOpname({ commit, dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiOpname.importOpname(params).then(res => {
			const data = res.data;
			commit("saveImportData", data.data.results);
			dispatch('success', data);
		})
		.catch( err => {
			dispatch('attempted', null, { root: true })
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal membuat Stok Opname'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async createOpname({ commit, dispatch }, params) {
		dispatch('isAttempting', null, { root: true })
		await apiOpname.createOpname(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data);
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal membuat Stok Opname'
			}, { root: true });
		});
		dispatch('attempted', null, { root: true })
	},
  getOptionOpnameforApprove({ commit, dispatch }) {
		return new Promise(() => {
			apiOption.getOptionOpnameforApprove().then(({ data: { data } }) => {
				commit('setOpnameforApprove', data.results)
			}).catch((err) => {
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		})
	},
  async approvalOpname({ commit, dispatch }, params) {
		dispatch('isAttempting', null, { root: true })
		await apiOpname.approvalOpname(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data);
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal membuat Stok Opname'
			}, { root: true });
		});
		dispatch('attempted', null, { root: true })
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
